export const LOAD_LOG_SOURCES_SUCCESS = "LOAD_LOG_SOURCES_SUCCESS";
export const LOAD_LOG_SOURCES_FAILED = "LOAD_LOG_SOURCES_FAILED";
export const LOAD_LOG_SOURCES = "LOAD_LOG_SOURCES";
export const SELECT_FILTER = "SELECT_FILTER";
export const SORT_LOG_SOURCES = "SORT_LOG_SOURCES";



// WEBPACK FOOTER //
// ./src/log-sources/logSourcesActionTypes.js